import React from 'react';
import { utility } from '../../../framework/utility/utilityProvider';

const LinkedInAdPreview = (props) => {
    let { text, landingPageUrl, ad = {} } = props?.dataItem || {};
    text = text?.trim() || "";
    landingPageUrl = landingPageUrl?.trim() || "";
    let image = (ad && Array.isArray(ad?.creatives)) ? ad.creatives[0]?.url : null;
    const displayImage = image || 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=600&auto=format&fit=crop';

    return (
        <div style={{
            width: '100%',
            maxWidth: '340px',
            border: '1px solid #dee2e6',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            overflow: 'hidden',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            backgroundColor: '#ffffff',
        }}>
            {/* Header */}
            <div style={{ 
                padding: '12px', 
                borderBottom: '1px solid #f0f2f5', 
                display: 'flex', 
                alignItems: 'center' 
            }}>
                <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: '#0A66C2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '8px',
                    color: 'white',
                    fontSize: '1rem'
                }}>
                    <i className="fa fa-brands fa-linkedin" />
                </div>
                <span style={{ fontSize: '0.8rem', fontWeight: '600', color: '#050505' }}>LinkedIn Preview</span>
            </div>

            {/* Profile Section */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 12px 8px 12px',
            }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src="https://bmsinfoglobal.com/wp-content/uploads/2023/05/bmslogo2.png"
                        alt="Logo"
                        style={{ 
                            width: '36px', 
                            height: '36px', 
                            borderRadius: '4px', // LinkedIn uses rounded squares for company pages
                            marginRight: '10px',
                            border: '1px solid #e9ecef',
                            objectFit: 'contain',
                            backgroundColor: '#fff'
                        }}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontSize: '0.8rem', fontWeight: '700', color: '#000000' }}>Bright Media Solution</span>
                        <span style={{ fontSize: '0.675rem', color: '#666666', marginTop: '1px' }}>15,203 followers</span>
                        <span style={{ fontSize: '0.625rem', color: '#666666', display: 'flex', alignItems: 'center', gap: '3px', marginTop: '1px' }}>
                            <span>Sponsored</span>
                            <span>•</span>
                            <i className='fa fa-globe' />
                        </span>
                    </div>
                </div>
                <button style={{ 
                    background: 'none', 
                    border: 'none', 
                    color: '#0A66C2', 
                    fontWeight: '700', 
                    fontSize: '0.8rem', 
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    padding: '4px 8px',
                    borderRadius: '4px',
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f4f9'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                    <i className='fa fa-plus' style={{ fontSize: '0.65rem' }} /> Follow
                </button>
            </div>

            {/* Post Text */}
            {text ? (
                <p style={{ 
                    padding: '4px 12px 12px 12px', 
                    fontSize: '0.8rem', 
                    color: '#000000', 
                    margin: 0,
                    lineHeight: '1.4',
                    whiteSpace: 'pre-wrap'
                }}>
                    {text}
                </p>
            ) : (
                <p style={{ 
                    padding: '4px 12px 12px 12px', 
                    fontSize: '0.8rem', 
                    color: '#8a8d91', 
                    margin: 0,
                    fontStyle: 'italic'
                }}>
                    Enter post text...
                </p>
            )}

            {/* Post Media & Action Box */}
            <div style={{ borderTop: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                <div style={{
                    width: '100%',
                    height: '180px',
                    backgroundColor: '#f3f6f8',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden'
                }}>
                    <img
                        src={displayImage}
                        alt="LinkedIn Ad Content"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                </div>
                
                {/* Landing page CTA banner */}
                <div style={{
                    padding: '12px',
                    backgroundColor: '#f3f6f8',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderTop: '1px solid #e9ecef',
                    gap: '8px'
                }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <h5 style={{ 
                            fontSize: '0.825rem', 
                            fontWeight: '600', 
                            color: '#000000', 
                            margin: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>
                            {landingPageUrl ? utility.subString(landingPageUrl, 30) : "brightmediasolution.com"}
                        </h5>
                        <span style={{ fontSize: '0.675rem', color: '#666666', marginTop: '2px', display: 'block' }}>
                            Visit company page
                        </span>
                    </div>
                    <button style={{
                        padding: '6px 14px',
                        fontSize: '0.75rem',
                        borderColor: '#0A66C2',
                        borderStyle: 'solid',
                        borderWidth: '1px',
                        color: '#0A66C2',
                        backgroundColor: 'transparent',
                        borderRadius: '16px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        transition: 'all 0.2s'
                    }}
                    onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f0f4f9'; e.currentTarget.style.borderWidth = '1.5px'; }}
                    onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.borderWidth = '1px'; }}
                    >
                        Learn More
                    </button>
                </div>
            </div>

            {/* LinkedIn Action Bar */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-around',
                padding: '4px 0',
                fontSize: '0.75rem',
                color: '#666666',
                fontWeight: '600',
            }}>
                {['Like', 'Comment', 'Repost', 'Send'].map((label) => {
                    const iconMap = {
                        Like: 'fa-thumbs-o-up',
                        Comment: 'fa-comment-o',
                        Repost: 'fa-retweet',
                        Send: 'fa-paper-plane'
                    };
                    return (
                        <div
                            key={label}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '8px 12px',
                                borderRadius: '4px',
                                transition: 'background-color 0.2s',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                            <i className={`fa ${iconMap[label]}`} style={{ fontSize: '0.85rem' }} />
                            {label}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LinkedInAdPreview;
